import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-between flex-wrap w-100"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Ver todos ")
const _hoisted_5 = { class: "d-flex justify-content-between flex-wrap w-100" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cerrar ")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src", "alt"]

import { ref } from "vue";
import { ButtonMessage, CardMessage } from "vue-advanced-chat";

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    buttons: null,
    cards: null
  },
  setup(__props: any) {

const props = __props as {
	name?: string;
	buttons?: ButtonMessage[];
	cards?: CardMessage[];
}



const total = ref(props.cards?.length);
const actual = ref(1);
const dialogVisible = ref(false);

function change(e: number) {
	actual.value = e + 1;
}
function redirect(url: string) {
	window.open(url);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_badge = _resolveComponent("el-badge")!

  return (__props.buttons)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.buttons.length <= 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.name), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "d-flex flex-row justify-content-between mt-2",
                  style: _normalizeStyle({
					width:
						i === __props.buttons.length - 1 && (i + 1) % 2 === 1
							? '100%'
							: 'calc(50% - .25rem)',
				})
                }, [
                  _createVNode(_component_el_button, {
                    class: _normalizeClass(["w-100 button-message", {
						'mb-1': i !== __props.buttons.length - 1,
					}]),
                    disabled: button.type !== 'web_url',
                    onClick: ($event: any) => (redirect(button.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(button.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "disabled", "onClick"])
                ], 4))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_button, {
                class: "w-100 button-message my-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_dialog, {
                modelValue: dialogVisible.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
                "append-to-body": "",
                title: "Opciones: ",
                width: "500"
              }, {
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "d-flex flex-row justify-content-between mt-2",
                        style: _normalizeStyle({
							width:
								i === __props.buttons.length - 1 && (i + 1) % 2 === 1
									? '100%'
									: 'calc(50% - .25rem)',
						})
                      }, [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(["w-100 button-message-modal", {
								'mb-1': i !== __props.buttons.length - 1,
							}]),
                          type: "info",
                          disabled: button.type !== 'web_url',
                          onClick: ($event: any) => (redirect(button.value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(button.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "disabled", "onClick"])
                      ], 4))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 64))
      ]))
    : (__props.cards)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_el_badge, {
            class: "message-badge",
            value: `${actual.value}/${total.value}`,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_carousel, {
                class: "card-container",
                autoplay: false,
                "indicator-position": "none",
                arrow: "always",
                onChange: change
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, i) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: i }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "image mb-2",
                          src: card.image,
                          alt: card.title
                        }, null, 8, _hoisted_9),
                        _createElementVNode("span", null, _toDisplayString(card.title), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.buttons, (button, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: j,
                            class: "d-flex flex-row justify-content-between mt-2"
                          }, [
                            _createVNode(_component_el_button, {
                              class: _normalizeClass(["w-100 button-message", {
								'mb-1': j !== card.buttons.length - 1,
							}]),
                              disabled: button.type !== 'web_url',
                              onClick: ($event: any) => (redirect(button.value))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(button.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "disabled", "onClick"])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : _createCommentVNode("", true)
}
}

})